// ** Redux Imports
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
// ** Axios Imports
import axios from '../../../../axios'

export const setLoading = createAsyncThunk('CampaignsStore/setLoading', async (loadingState) => ({ ...loadingState }))

export const getData = createAsyncThunk('CampaignsStore/getData', async (params, { dispatch }) => {
    dispatch(setLoading({ getData: true }))
    const accessToken = window.localStorage.getItem('accessToken')
    const options = {
        headers : {'Authorization': 'Bearer '+accessToken,
            'Content-Type': 'application/x-www-form-urlencoded',
        }
    }
    const response = await axios.get('/api/campaign/get_campaigns', { params, ...options })
    // consle.log({ response })
    dispatch(setLoading({ getData: false }))
    return {
        params,
        data: response.data
    }
})

export const CampaignsStore = createSlice({
    name: 'CampaignsStore',
    initialState: {
        data: [],
        totalRecords: 1,
        params: {},
        loadingState: { getData: false }
    },
    reducers: {},
    extraReducers: builder => {
        builder
            .addCase(getData.fulfilled, (state, action) => {
                state.data = action.payload.data.campaign
                state.totalRecords = action.payload.data.totalRecords
                state.params = action.payload.params
            })
            .addCase(setLoading.fulfilled, (state, action) => {
                state.loadingState = action.payload
            })
    }
})

export default CampaignsStore.reducer
